import { styled } from "@mui/material/styles";
import { VariantType } from "notistack";
import { Colors } from '../../../constants';

interface CoreToastIconProps {
	variant: VariantType;
}

const getBgColor = (variant: VariantType): string => {
	switch (variant) {
		case "info":
			return Colors.white_a10;
		case "error":
			return Colors['FB5353_a10'];
		case "success":
			return Colors['00DF80_a10'];
		case "warning":
			return Colors['F19239_a10'];
		case "default":
		default:
			return Colors.white_a10;
	}
};

const getColor = (variant: VariantType): string => {
	switch (variant) {
		case "info":
			return Colors['C5C5C5'];
		case "error":
			return Colors['FB5353'];
		case "success":
			return Colors['00DF80'];
		case "warning":
			return Colors['F19239'];
		case "default":
		default:
			return Colors['C5C5C5'];
	}
};

export const CoreToastIcon = styled('div')<CoreToastIconProps>(({ variant }) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '32px',
	height: '32px',
	borderRadius: '50%',
	background: getBgColor(variant),
	color: Colors.white,

	'& >svg': {
		width: '20px',
		height: '20px',
		color: getColor(variant),
	}
}));
